<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-col md:flex-row gap-4 items-center">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Rent Booking - {{ booking?.refNo }}</h2>
  </div>
  <div class="flex gap-3">
    <!--    With Permissions-->
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'COMPLETED', true)"
      [nzColor]="'#3ab200'" class="rounded-full">Completed
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'CANCELLED', true)"
      class="rounded-full hover:cursor-pointer" [nzColor]="'#F3454C'"
      nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzPlacement="bottomCenter">Cancelled
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'RESERVATION', true)"
      [nzColor]="'#FF8C00'" class="rounded-full hover:cursor-pointer"
      nz-popconfirm nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzPlacement="bottomCenter">Reservation
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'ON_RENT', true)"
      [nzColor]="'#4655f5'" class="rounded-full hover:cursor-pointer"
      nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzPlacement="bottomCenter">On Rent
    </nz-tag>

    <!--    Without Permissions-->
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'COMPLETED', false)"
      [nzColor]="'#3ab200'" class="rounded-full">Completed
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'CANCELLED', false)"
      class="rounded-full" [nzColor]="'#F3454C'"
    >Cancelled
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'RESERVATION', false)"
      [nzColor]="'#FF8C00'" class="rounded-full">Reservation
    </nz-tag>
    <nz-tag
      *ngIf="havePermissionWithStatus(booking?.status, 'RENT_BOOKING_CHANGE_STATUS', 'ON_RENT', false)"
      [nzColor]="'#4655f5'" class="rounded-full">On Rent
    </nz-tag>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item nz-popconfirm
            *ngIf="( booking?.status === 'CANCELLED')"
            nzPopconfirmTitle="Are you sure you want change the status to Reservation?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('RESERVATION')">Reservation
        </li>
        <li nz-menu-item nz-popconfirm
            *ngIf="(booking?.status === 'RESERVATION') && canChangeToOnRent()"
            nzPopconfirmTitle="Are you sure you want change the status to On Rent?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('ON_RENT')">On Rent
        </li>
        <li nz-menu-item nz-popconfirm
            *ngIf="( booking?.status === 'ON_RENT')"
            nzPopconfirmTitle="Are you sure you want change the status to Completed?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('COMPLETED')">Completed
        </li>
        <li nz-menu-item nz-popconfirm
            *ngIf="(booking?.status === 'RESERVATION')"
            nzPopconfirmTitle="Are you sure you want change the status to Cancelled?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('CANCELLED')">Cancelled
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
  <div *ngIf="(booking?.status === 'RESERVATION') && !canChangeToOnRent()">
    <p class="text-primary small-text">Need to allocate a Vehicle before start the tour!</p>
  </div>
</div>
<nz-tabset [(nzSelectedIndex)]="activeTabIndex">
  <nz-tab *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW'" nzTitle="Booking Details">

    <div [ngClass]="!loading ? 'block' : 'hidden'">

      <section class="mt-5">
        <nz-card>
          <div class="flex justify-between items-center">
            <h5 class="text-primary">Booking Details</h5>
            <div>
              <button nz-button nzType="primary" style="margin-right: 10px"
                      *ngIf="havePermissionWithStatus(this.booking?.allocationDetails?.driverCategory, 'REPORT_GENERATE', 'OUTSOURCE_DRIVER', true)"
                      (click)="showReportGenerate(false);generatePdf()">Invoice - Outsourced Vehicles
              </button>
              <button nz-button nzType="primary" (click)="navigateTo('edit')" [disabled]="booking?.status === 'COMPLETED'">Edit Details</button>
            </div>

          </div>
          <div class="mt-5 grid md:grid-cols-2 gap-8">
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Booking Received Date</p>
                <p class="subject-data">{{ booking?.bookingDetails?.bookingReceivedDate | date: 'dd-MM-y' }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Booking type </p>
                <p class="subject-data">{{ convertToNormalString(booking?.bookingDetails?.bookingType) }}</p>
              </div>
              <div *ngIf="booking?.bookingDetails?.bookingType === 'THROUGH_AGENT'" class="item-row">
                <p class="subject-name">Agent Booking Reference </p>
                <p class="subject-data">{{
                    booking?.bookingDetails?.bookingType === 'THROUGH_AGENT' ?
                      booking?.bookingDetails?.bookingReferenceNo : '-'
                  }}</p>
              </div>
              <div *ngIf="booking?.bookingDetails?.bookingType === 'THROUGH_AGENT'" class="item-row">
                <p class="subject-name">Agent</p>
                <p class="subject-data">{{
                    booking?.bookingDetails?.bookingType === 'THROUGH_AGENT' ?
                      booking?.bookingDetails?.agent?.name : '-'
                  }}</p>
              </div>
              <div *ngIf="booking?.bookingDetails?.bookingType === 'THROUGH_AGENT'" class="item-row">
                <p class="subject-name">Broker Name</p>
                <p class="subject-data">{{
                    booking?.bookingDetails?.bookingType === 'THROUGH_AGENT' ?
                      booking?.bookingDetails?.brokerName : '-'
                  }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>


      <section class="mt-5">
        <nz-card>
          <div class="flex justify-between items-center">
            <h5 class="text-primary">Customer Details</h5>
          </div>
          <div class="mt-7">
            <div class="grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div class="sub-section">
                <div class="item-row">
                  <p class="subject-name">Full Name</p>
                  <a (click)="navigateTo('customer')" class="link-text col-span-9 custom-res-mobile">
                    <p class="subject-data">{{ booking?.customerDetails?.customer?.renterDetails?.fullName }}</p>
                  </a>
                </div>
                <div class="item-row">
                  <p class="subject-name">Country</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.customer?.renterDetails?.homeCountry }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name ">Home Address</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.customer?.renterDetails?.homeAddress ? booking?.customerDetails?.customer?.renterDetails?.homeAddress : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Contact Number (Home Country)</p>
                  <div class="subject-data">
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                       href="tel:{{booking?.customerDetails?.customer?.renterDetails?.contactNo}}">{{ booking?.customerDetails?.customer?.renterDetails?.contactNo }}</a>
                    </p>
                  </div>
                </div>
                <div class="item-row">
                  <p class="subject-name">Date of Birth</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.customer?.renterDetails?.dob | date: 'dd-MM-Y' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name ">E-Mail</p>
                  <p
                    class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                    href="mailto:{{booking?.customerDetails?.customer?.renterDetails?.email}}">{{ booking?.customerDetails?.customer?.renterDetails?.email }}</a>
                  </p>
                </div>
              </div>
              <div class="sub-section" style="height: 100%">
                <div class="item-row">
                  <p class="subject-name">Local Address/ Name of the Hotel staying on the last day</p>
                  <p class="subject-data">{{ booking?.customerDetails?.localAddress }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Local Contact Number</p>
                  <div class="subject-data">
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                       href="tel:{{booking?.customerDetails?.localContactNo}}">{{ booking?.customerDetails?.localContactNo }}</a>
                    </p>
                  </div>
                </div>
                <div class="item-row">
                  <p class="subject-name ">local permit requirements</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.localPermitRequirements ? 'Yes' : 'No' }}</p>
                </div>
              </div>

            </div>
          </div>

          <div class="mt-7">
            <div class="grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div class="sub-section">
                <p class="sub-topic">Passport Details</p>
                <div class="item-row">
                  <p class="subject-name">Passport Number</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.customer?.passportLicenceDetails?.passportNo }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.customer?.passportLicenceDetails?.issueDatePass |
                        date: 'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.customer?.passportLicenceDetails?.expiryDatePass |
                        date: 'dd-MM-y'
                    }}</p>
                </div>
              </div>
              <div class="sub-section">
                <p class="sub-topic">Driving License Details</p>
                <div class="item-row">
                  <p class="subject-name">Driving License Number </p>
                  <p class="subject-data">
                    {{ booking?.customerDetails?.customer?.passportLicenceDetails?.drivingLicenceNo }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.customer?.passportLicenceDetails?.issueDateLicence
                        | date: 'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">
                    {{ booking?.customerDetails?.customer?.passportLicenceDetails?.expiryDateLicence | date: 'dd-MM-y' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-7">
            <div class="grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div *ngIf="booking?.customerDetails?.localDrivingLicenseCheck" class="sub-section">
                <p class="sub-topic">Local Driving License Details</p>
                <div class="item-row">
                  <p class="subject-name">Local Driving License Number</p>
                  <p class="subject-data">
                    {{ booking?.customerDetails?.localDrivingLicenseDetails?.localDrivingPermitNumber }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.localDrivingLicenseDetails?.issuedDate | date:
                        'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.localDrivingLicenseDetails?.expiryDate | date:
                        'dd-MM-y'
                    }}</p>
                </div>
              </div>
              <div *ngIf="booking?.customerDetails?.localDrivingLicenseCheck" class="sub-section">
                <p class="subject-name">Attachments</p>
                <div *ngIf="booking?.customerDetails?.localDrivingLicenseDetails?.attachments?.length > 0"
                     class="flex flex-row gap-2 items-center py-2">
                  <div *ngFor="let at of booking?.customerDetails?.localDrivingLicenseDetails?.attachments"
                       class="flex flex-col">
                    <a href="{{at?.url}}" [nz-tooltip]="" target="_blank"><span nz-icon nzType="file" class="text-sm"
                                                                                nzTheme="outline"></span><span
                      class="ml-2 text-sm text-black"> - {{ at?.name }}</span></a>
                  </div>
                </div>
                <div *ngIf="!(booking?.customerDetails?.localDrivingLicenseDetails?.attachments?.length > 0)"
                     class="flex flex-row gap-2 items-center py-2">
                  <p class="subject-data">-</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="booking?.customerDetails?.secondDriverCheck" class="mt-7">
            <h6 class="mb-6 sub-topic">2nd Driver Details</h6>
            <div class="grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div class="sub-section">
                <div class="item-row">
                  <p class="subject-name">Name</p>
                  <p class="subject-data">{{ booking?.customerDetails?.secondDriverDetails?.driverName }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Local Permit Requirements</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.secondDriverDetails?.localPermitRequirements ?
                        'Yes' : 'No'
                    }}</p>
                </div>
              </div>
              <div class="sub-section ">
                <p class="sub-topic">Passport Details</p>
                <div class="item-row">
                  <p class="subject-name">Passport Number</p>
                  <p class="subject-data">{{ booking?.customerDetails?.secondDriverDetails?.passportNumber }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.secondDriverDetails?.passportIssuedDate | date:
                        'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.secondDriverDetails?.passportExpiryDate | date:
                        'dd-MM-y'
                    }}</p>
                </div>
              </div>
              <div class="sub-section">
                <p class="sub-topic">Driving License Details</p>
                <div class="item-row">
                  <p class="subject-name">Driving License Number </p>
                  <p class="subject-data">{{ booking?.customerDetails?.secondDriverDetails?.drivingLicenseNumber }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.secondDriverDetails?.drivingLicenseIssuedDate |
                        date: 'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">{{
                      booking?.customerDetails?.secondDriverDetails?.drivingLicenseExpiryDate |
                        date: 'dd-MM-y'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issued Country</p>
                  <p
                    class="subject-data">{{ booking?.customerDetails?.secondDriverDetails?.drivingLicenseIssuedCountry }}</p>
                </div>
              </div>
              <div class="sub-section">
                <p class="sub-topic">Local Driving License Details</p>
                <div class="item-row">
                  <p class="subject-name">Local Driving License Number</p>
                  <p class="subject-data">
                    {{
                      booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.localDrivingPermitNumber
                        ?
                        booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.localDrivingPermitNumber
                        : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Issue Date</p>
                  <p class="subject-data">
                    {{
                      booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.issuedDate ?
                        (booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.issuedDate | date:
                          'dd-MM-y') : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Expiry Date</p>
                  <p class="subject-data">
                    {{
                      booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.expiryDate ?
                        (booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.expiryDate | date:
                          'dd-MM-y') : '-'
                    }}</p>
                </div>
              </div>
              <div
                *ngIf="booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.attachments?.length > 0"
                class="sub-section">
                <p class="subject-name">Attachments</p>
                <div
                  *ngIf="booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.attachments?.length > 0"
                  class="flex flex-row gap-2 items-center py-2">
                  <div
                    *ngFor="let at of booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.attachments"
                    class="flex flex-col">
                    <a href="{{at?.url}}" [nz-tooltip]="" target="_blank"><span nz-icon nzType="file" class="text-sm"
                                                                                nzTheme="outline"></span><span
                      class="ml-2 text-sm text-black"> - {{ at?.name }}</span></a>
                  </div>
                </div>
                <div
                  *ngIf="!(booking?.customerDetails?.secondDriverDetails?.localDrivingLicenseDetails?.attachments?.length > 0)"
                  class="flex flex-row gap-2 items-center py-2">
                  <p class="subject-data">-</p>
                </div>
              </div>
            </div>
          </div>
        </nz-card>
      </section>

      <section class="mt-5">
        <nz-card>
          <h5 class="text-primary">Tour Details</h5>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Vehicle Category</p>
                <p class="subject-data">{{ booking?.tourDetails?.vehicleCategory?.name }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">No. of Passengers</p>
                <p class="subject-data">{{ booking?.tourDetails?.numberOfPassengers }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Number of Days</p>
                <p class="subject-data">{{ booking?.tourDetails?.numberOfDays }}</p>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Millage – Limited/ Unlimited</p>
                <p class="subject-data">{{ booking?.tourDetails?.mileagePreference | titlecase }}</p>
              </div>
              <div *ngIf="booking?.tourDetails?.mileagePreference === 'LIMITED'" class="item-row">
                <p class="subject-name">Limited Millage allowed</p>
                <p class="subject-data">{{ booking?.tourDetails?.limitedMileage | unit }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Cost per extra millage</p>
                <p class="subject-data">{{ booking?.tourDetails?.costPerExtraMileage }}
                  {{ booking?.tourDetails?.costPerExtraMileageCurrencyDetails?.currencyCode }}</p>
              </div>
            </div>
          </div>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <p class="sub-topic">Arrival Details</p>
              <div class="item-row">
                <p class="subject-name">Arrival Date</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.arrivalInformation?.arrivalDateAndTime ?
                      (booking?.tourDetails?.arrivalInformation?.arrivalDateAndTime | date: 'dd-MM-y') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Arrival Time</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.arrivalInformation?.arrivalDateAndTime ?
                      (booking?.tourDetails?.arrivalInformation?.arrivalDateAndTime | date: 'hh:mm:a') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Arrival Flight No.</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.arrivalInformation?.arrivalFlightNo ?
                      booking?.tourDetails?.arrivalInformation?.arrivalFlightNo : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Pick Up Address</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.arrivalInformation?.pickUpLocation ?
                      booking?.tourDetails?.arrivalInformation?.pickUpLocation : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Arrival Handler</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.arrivalInformation?.arrivalHandler ?
                      (booking?.arrivalHandler?.firstname + " " +
                        booking?.arrivalHandler?.lastname) : '-'
                  }}</p>
              </div>
            </div>
            <div class="sub-section">
              <p class="sub-topic">Departure Details</p>
              <div class="item-row">
                <p class="subject-name">Departure Date</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.departureDateAndTime ?
                      (booking?.tourDetails?.departureInformation?.departureDateAndTime | date: 'dd-MM-y') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Departure Time</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.departureDateAndTime ?
                      (booking?.tourDetails?.departureInformation?.departureDateAndTime | date: 'hh:mm:a') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Departure Flight No.</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.departureFlightNo ?
                      booking?.tourDetails?.departureInformation?.departureFlightNo : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Drop Off Address</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.dropOffLocation ?
                      booking?.tourDetails?.departureInformation?.dropOffLocation : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Drop Off City</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.dropOffCity ?
                      booking?.tourDetails?.departureInformation?.dropOffCity : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Departure Handler</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.departureInformation?.departureHandler ?
                      (booking?.departureHandler?.firstname + " " +
                        booking?.departureHandler?.lastname) : '-'
                  }}</p>
              </div>
            </div>
            <div class="sub-section">
              <p class="sub-topic">Actual Details</p>
              <div class="item-row">
                <p class="subject-name">Actual Start Date </p>
                <p class="subject-data">{{
                    booking?.tourDetails?.actualInformation?.actualStartDateAndTime ?
                      (booking?.tourDetails?.actualInformation?.actualStartDateAndTime | date: 'dd-MM-y') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Actual Start Time </p>
                <p class="subject-data">{{
                    booking?.tourDetails?.actualInformation?.actualStartDateAndTime ?
                      (booking?.tourDetails?.actualInformation?.actualStartDateAndTime | date: 'hh:mm:a') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Actual End Date </p>
                <p class="subject-data">{{
                    booking?.tourDetails?.actualInformation?.actualEndDateAndTime ?
                      (booking?.tourDetails?.actualInformation?.actualEndDateAndTime | date: 'dd-MM-y') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Actual End Time </p>
                <p class="subject-data">{{
                    booking?.tourDetails?.actualInformation?.actualEndDateAndTime ?
                      (booking?.tourDetails?.actualInformation?.actualEndDateAndTime | date: 'hh:mm:a') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Extend booking </p>
                <p class="subject-data">{{ booking?.tourDetails?.actualInformation?.isExtendedBooking ? 'Yes' : 'No' }}
                </p>
              </div>
              <div class="item-row">
                <p class="subject-name">Number of days</p>
                <p class="subject-data">{{
                    booking?.tourDetails?.actualInformation?.noOfDays ?
                      booking?.tourDetails?.actualInformation?.noOfDays + 'days' : '-'
                  }}</p>
              </div>
            </div>
            <div
              *ngIf="booking?.allocationDetails?.endMileage &&
              booking?.allocationDetails?.startMileage"
              class="sub-section">
              <div class="item-row">
                <p class="subject-name">Total KM</p>
                <p class="subject-data">{{
                    (booking?.allocationDetails?.endMileage &&
                      booking?.allocationDetails?.startMileage) ? ((booking?.allocationDetails?.endMileage -
                      booking?.allocationDetails?.startMileage) | unit) : '-'
                  }}</p>
              </div>
              <div *ngIf="booking?.tourDetails?.mileagePreference === 'LIMITED'" class="item-row">
                <p class="subject-name">KM Exceeded</p>
                <p class="subject-data">{{ getExceededDistance() }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>

      <section *ngIf="!(booking?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER')" class="mt-5">
        <nz-card>
          <div class="flex justify-between gap-2 flex-col xl:flex-row">
            <div class="flex flex-col gap-2">
              <h5 class="text-primary">Vehicle Details</h5>
            </div>

            <div class="flex flex-wrap lg:flex-nowrap lg:flex-row gap-2 items-center xl:justify-end ">
              <button nz-button *ngIf="booking?.status === 'ON_RENT' && (booking?.allocationList?.length < 3)"
                      (click)="handleAddAnotherAllocation()">Add Another Allocation
              </button>
              <button nz-button (click)="navigateTo('initial-allocated-vehicle-accident')">Add Accident Record</button>
              <button nz-button (click)="navigateTo('vehicle-inspection')">Add Inspection Record</button>
              <button *ngIf="checkCanShowGenerateInventoryReport()" nz-button
                      (click)="showGenerateInventoryReportPopup()">Generate Inventory Report
              </button>
            </div>
          </div>


          <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section" style="height: 100%">
              <img *ngIf="allocatedVehicle?.image" height="nzAutosize" width="100%"
                   [src]="allocatedVehicle?.image" alt="Vehicle">
              <img *ngIf="!allocatedVehicle?.image" height="nzAutosize" width="100%"
                   src="assets/img/image-placeholder.png" alt="Vehicle">
            </div>
            <div class="sub-section">
              <div *ngIf="booking?.allocationDetails?.isUpgraded" class="item-row">
                <p class="subject-name">Vehicle Upgrade </p>
                <p class="subject-data">{{ booking?.allocationDetails?.isUpgraded ? 'Yes' : 'No' }}</p>
              </div>
              <div *ngIf="booking?.allocationDetails?.isDowngraded" class="item-row">
                <p class="subject-name">Vehicle Downgrade</p>
                <p class="subject-data">{{ booking?.allocationDetails?.isDowngraded ? 'Yes' : 'No' }}</p>
              </div>
              <div *ngIf="(booking?.allocationDetails?.isDowngraded || booking?.allocationDetails?.isUpgraded)"
                   class="item-row">
                <p class="subject-name">Vehicle Category</p>
                <p class="subject-data">{{
                    (booking?.allocationDetails?.isDowngraded ||
                      booking?.allocationDetails?.isUpgraded) ?
                      booking?.allocationDetails?.vehicleCategory?.name : '-'
                  }}</p>
              </div>
              <div
                *ngIf="(booking?.allocationDetails?.isUpgraded && booking?.allocationDetails?.isComplementary)"
                class="item-row">
                <p class="subject-name">complementary</p>
                <p class="subject-data">{{ booking?.allocationDetails?.isComplementary ? 'Yes' : 'No' }}</p>
              </div>
              <div
                *ngIf="(booking?.allocationDetails?.isUpgraded && booking?.allocationDetails?.isComplementary)"
                class="item-row">
                <p class="subject-name">Reason</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.isComplementary ?
                      booking?.allocationDetails?.reason : '-'
                  }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.brand" class="item-row">
                <p class="subject-name">Brand</p>
                <p class="subject-data">{{ allocatedVehicle?.brand }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.model" class="item-row">
                <p class="subject-name">Model</p>
                <p class="subject-data">{{ allocatedVehicle?.model }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.fuelType" class="item-row">
                <p class="subject-name">Fuel Type</p>
                <p class="subject-data">{{ allocatedVehicle?.fuelType }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.transmission" class="item-row">
                <p class="subject-name">Transmission</p>
                <p class="subject-data">{{ allocatedVehicle?.transmission }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.registerNumber" class="item-row">
                <p class="subject-name">Reg. Number</p>
                <p class="subject-data">{{ allocatedVehicle?.registerNumber }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.numberOfSeats" class="item-row">
                <p class="subject-name">Number of Seats</p>
                <p class="subject-data">{{ allocatedVehicle?.numberOfSeats }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.color" class="item-row">
                <p class="subject-name">Color</p>
                <p class="subject-data">{{ allocatedVehicle?.color }}</p>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Start Mileage</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.startMileage ?
                      (booking?.allocationDetails?.startMileage | unit) : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Start Fuel</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.startFuel ? (booking?.allocationDetails?.startFuel
                      | unit: '%') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Mileage</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.endMileage ?
                      (booking?.allocationDetails?.endMileage | unit) : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Fuel</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.endFuel ? (booking?.allocationDetails?.endFuel |
                      unit: '%') : '-'
                  }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>

      <section *ngIf="booking?.allocationDetails?.isDriverPromote" class="mt-5">
        <nz-card>
          <div class="flex flex-col md:flex-row md:justify-between items-center">
            <h5 class="text-primary">Chaffer Driver Details</h5>
            <div class="flex">
              <button *ngIf="booking?.status === 'ON_RENT' && (booking?.allocationList?.length < 3) &&
              booking?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'"
                      (click)="handleAddAnotherAllocation()" nz-button>
                Add Another Allocation
              </button>
            </div>
          </div>
          <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <div>
                <div class="item-row">
                  <p class="subject-name">Driver Promote Due to</p>
                  <p class="subject-data">{{
                      booking?.allocationDetails?.driverPromotionDue ?
                        booking?.allocationDetails?.driverPromotionDue : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Driver Category </p>
                  <p class="subject-data">{{
                      booking?.allocationDetails?.driverCategory ?
                        (booking?.allocationDetails?.driverCategory === 'SR_DRIVER' ? 'SR Driver' : 'Outsource Driver') :
                        '-'
                    }}</p>
                </div>
              </div>
              <div>
                <div *ngIf="booking?.allocationDetails?.isDriverPromotionCompCheck" class="item-row">
                  <p class="subject-name">Complementary</p>
                  <p
                    class="subject-data">{{ booking?.allocationDetails?.isDriverPromotionCompCheck ? 'Yes' : 'No' }}</p>
                </div>
                <div *ngIf="booking?.allocationDetails?.isDriverPromotionCompCheck" class="item-row">
                  <p class="subject-name">Reason</p>
                  <p class="subject-data">{{
                      booking?.allocationDetails?.driverPromotionReason ?
                        booking?.allocationDetails?.driverPromotionReason : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Can Drive</p>
                  <p *ngFor="let can of booking?.allocationDetails?.allocatedDriver?.canDrive" class="subject-data">
                    {{
                      can.checked && can.label === "Light Vehicles" ? 'Light Vehicles' : (can.checked && can.label ===
                      "Heavy Vehicles" ? 'Heavy Vehicles' : '-')
                    }}</p>
                </div>
              </div>
              <div *ngIf="booking?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'">
                <div class="item-row">
                  <p class="subject-name">Outsourced Rate</p>
                  <p
                    class="subject-data">{{ booking?.allocationDetails?.outsourcedRate + ' ' + booking?.allocationDetails?.outsourcedRateCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Supplier Name</p>
                  <a class="link-text" (click)="navigateTo('supplier')">
                    <p class="subject-data">{{
                        booking?.allocatedDriversSupplier?.supplierDetails?.name ?
                          booking?.allocatedDriversSupplier?.supplierDetails?.name : '-'
                      }}</p>
                  </a>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Driver Name</p>
                <a class="link-text" (click)="navigateTo('driver')">
                  <p class="subject-data">{{
                      booking?.allocationDetails?.allocatedDriver?.fullName ?
                        booking?.allocationDetails?.allocatedDriver?.fullName : '-'
                    }}</p>
                </a>
              </div>
              <div class="item-row">
                <p class="subject-name">NIC</p>
                <p class="subject-data">{{
                    booking?.allocationDetails?.allocatedDriver?.nicNo ?
                      booking?.allocationDetails?.allocatedDriver?.nicNo : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Mobile Number </p>
                <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{booking?.allocationDetails?.allocatedDriver?.mobileNumber ?
                  booking?.allocationDetails?.allocatedDriver?.mobileNumber : '-'}}">{{
                    booking?.allocationDetails?.allocatedDriver?.mobileNumber ?
                      booking?.allocationDetails?.allocatedDriver?.mobileNumber : '-'
                  }}</a></p>
              </div>
              <div class="item-row">
                <p class="subject-name">Email</p>
                <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="mailto:{{booking?.allocationDetails?.allocatedDriver?.email ?
                  booking?.allocationDetails?.allocatedDriver?.email : '-'}}">{{
                    booking?.allocationDetails?.allocatedDriver?.email ?
                      booking?.allocationDetails?.allocatedDriver?.email : '-'
                  }}</a></p>
              </div>
            </div>
            <div *ngIf="booking?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'" class="sub-section">
              <div *ngIf="allocatedVehicle?.brand" class="item-row">
                <p class="subject-name">Brand</p>
                <p class="subject-data">{{ allocatedVehicle?.brand }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.model" class="item-row">
                <p class="subject-name">Model</p>
                <p class="subject-data">{{ allocatedVehicle?.model }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.registerNumber" class="item-row">
                <p class="subject-name">Reg. Number</p>
                <p class="subject-data">{{ allocatedVehicle?.registerNumber }}</p>
              </div>
              <div *ngIf="allocatedVehicle?.yearOfManufacture" class="item-row">
                <p class="subject-name">Year of Manufacture</p>
                <p class="subject-data">{{ allocatedVehicle?.yearOfManufacture | date: 'y' }}</p>
              </div>
              <div *ngIf="booking?.allocationDetails?.startMileage" class="item-row">
                <p class="subject-name">Start Mileage</p>
                <p
                  class="subject-data">{{ booking?.allocationDetails?.startMileage ? (booking?.allocationDetails?.startMileage | unit) : '-' }}</p>
              </div>
              <div *ngIf="booking?.allocationDetails?.startFuel" class="item-row">
                <p class="subject-name">Start Fuel</p>
                <p
                  class="subject-data">{{ booking?.allocationDetails?.startFuel ? (booking?.allocationDetails?.startFuel | unit: '%') : '-' }}</p>
              </div>
              <div *ngIf="booking?.allocationDetails?.endMileage" class="item-row">
                <p class="subject-name">End Mileage</p>
                <p
                  class="subject-data">{{ booking?.allocationDetails?.endMileage ? (booking?.allocationDetails?.endMileage | unit) : '-' }}</p>
              </div>
              <div *ngIf="booking?.allocationDetails?.endFuel" class="item-row">
                <p class="subject-name">End Fuel</p>
                <p
                  class="subject-data">{{ booking?.allocationDetails?.endFuel ? (booking?.allocationDetails?.endFuel | unit : '%') : '-' }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>
      <section *ngFor="let allocation of booking?.allocationList; index as i" class="mt-5">
        <nz-card *ngIf="!(allocation?.driverCategory === 'OUTSOURCE_DRIVER')">
          <div class="flex flex-col md:flex-row md:justify-start items-center">
            <h5 class="text-primary">Previous Allocation (No - {{ getNumberWithPad(i + 1) }}) </h5>
          </div>
          <div class="flex">
            <h5 class="sub-topic">Vehicle Details </h5>
          </div>

          <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section" style="height: 100%">
              <img *ngIf="allocation?.allocatedVehicle?.image" height="nzAutosize" width="100%"
                   [src]="allocation?.allocatedVehicle?.image" alt="Vehicle">
              <img *ngIf="!allocation?.allocatedVehicle?.image" height="nzAutosize" width="100%"
                   src="assets/img/image-placeholder.png" alt="Vehicle">
            </div>
            <div class="sub-section">
              <div *ngIf="allocation?.isUpgraded" class="item-row">
                <p class="subject-name">Vehicle Upgrade </p>
                <p class="subject-data">{{ allocation?.isUpgraded ? 'Yes' : 'No' }}</p>
              </div>
              <div *ngIf="allocation?.isDowngraded" class="item-row">
                <p class="subject-name">Vehicle Downgrade</p>
                <p class="subject-data">{{ allocation?.isDowngraded ? 'Yes' : 'No' }}</p>
              </div>
              <div *ngIf="(allocation?.isDowngraded || allocation?.isUpgraded)"
                   class="item-row">
                <p class="subject-name">Vehicle Category</p>
                <p class="subject-data">{{
                    (allocation?.isDowngraded ||
                      allocation?.isUpgraded) ?
                      allocation?.vehicleCategory?.name : '-'
                  }}</p>
              </div>
              <div
                *ngIf="((allocation?.isDowngraded || allocation?.isUpgraded) && (allocation?.isComplementary))"
                class="item-row">
                <p class="subject-name">complementary</p>
                <p class="subject-data">{{ allocation?.isComplementary ? 'Yes' : 'No' }}</p>
              </div>
              <div
                *ngIf="((allocation?.isDowngraded || allocation?.isUpgraded) && (allocation?.isComplementary))"
                class="item-row">
                <p class="subject-name">Reason</p>
                <p class="subject-data">{{
                    allocation?.isComplementary ?
                      allocation?.reason : '-'
                  }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.brand" class="item-row">
                <p class="subject-name">Brand</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.brand }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.model" class="item-row">
                <p class="subject-name">Model</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.model }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.fuelType" class="item-row">
                <p class="subject-name">Fuel Type</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.fuelType }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.transmission" class="item-row">
                <p class="subject-name">Transmission</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.transmission }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.registrationNo" class="item-row">
                <p class="subject-name">Reg. Number</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.registrationNo }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.numberOfSeats" class="item-row">
                <p class="subject-name">Number of Seats</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.numberOfSeats }}</p>
              </div>
              <div *ngIf="allocation?.allocatedVehicle?.color" class="item-row">
                <p class="subject-name">Color</p>
                <p class="subject-data">{{ allocation?.allocatedVehicle?.color }}</p>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Start Mileage</p>
                <p class="subject-data">{{
                    allocation?.startMileage ?
                      (allocation?.startMileage | unit) : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Start Fuel</p>
                <p class="subject-data">{{
                    allocation?.startFuel ? (allocation?.startFuel
                      | unit: '%') : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Mileage</p>
                <p class="subject-data">{{
                    allocation?.endMileage ?
                      (allocation?.endMileage | unit) : '-'
                  }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Fuel</p>
                <p class="subject-data">{{
                    allocation?.endFuel ? (allocation?.endFuel |
                      unit: '%') : '-'
                  }}</p>
              </div>
            </div>
          </div>
        </nz-card>

        <nz-card class="mt-5" *ngIf="allocation?.isDriverPromote">
          <div class="flex flex-col md:flex-row md:justify-between items-center">
            <h5 class="text-primary">Previous Allocation (No - {{ getNumberWithPad(i + 1) }}) </h5>
          </div>

          <div class="flex">
            <h5 class="sub-topic">Chaffer Driver Details </h5>
          </div>

          <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <div>
                <div class="item-row">
                  <p class="subject-name">Driver Promote Due to</p>
                  <p class="subject-data">{{
                      allocation?.driverPromotionDue ?
                        allocation?.driverPromotionDue : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Driver Category </p>
                  <p class="subject-data">{{
                      allocation?.driverCategory ?
                        (allocation?.driverCategory === 'SR_DRIVER' ? 'SR Driver' : 'Outsource Driver') :
                        '-'
                    }}</p>
                </div>
              </div>
              <div>
                <div *ngIf="allocation?.isDriverPromotionCompCheck" class="item-row">
                  <p class="subject-name">Complementary</p>
                  <p class="subject-data">{{ allocation?.isDriverPromotionCompCheck ? 'Yes' : 'No' }}</p>
                </div>
                <div *ngIf="allocation?.isDriverPromotionCompCheck" class="item-row">
                  <p class="subject-name">Reason</p>
                  <p class="subject-data">{{
                      allocation?.driverPromotionReason ?
                        allocation?.driverPromotionReason : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Can Drive</p>
                  <p *ngFor="let can of allocation?.allocatedDriver?.canDrive" class="subject-data">
                    {{
                      can.checked && can.label === "Light Vehicles" ? 'Light Vehicles' : (can.checked && can.label ===
                      "Heavy Vehicles" ? 'Heavy Vehicles' : '-')
                    }}</p>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <div>
                <div class="item-row">
                  <p class="subject-name">Driver Name</p>
                  <a class="link-text" (click)="navigateTo('driver')">
                    <p class="subject-data">{{
                        allocation?.allocatedDriver?.fullName ?
                          allocation?.allocatedDriver?.fullName : '-'
                      }}</p>
                  </a>
                </div>
                <div class="item-row">
                  <p class="subject-name">NIC</p>
                  <p class="subject-data">{{
                      allocation?.allocatedDriver?.nicNo ?
                        allocation?.allocatedDriver?.nicNo : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Mobile Number </p>
                  <p class="subject-data">{{
                      allocation?.allocatedDriver?.mobileNumber ?
                        allocation?.allocatedDriver?.mobileNumber : '-'
                    }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Email</p>
                  <p class="subject-data">{{
                      allocation?.allocatedDriver?.email ?
                        allocation?.allocatedDriver?.email : '-'
                    }}</p>
                </div>
              </div>
              <div *ngIf="allocation?.driverCategory === 'OUTSOURCE_DRIVER'">
                <div class="item-row">
                  <p class="subject-name">Outsourced Rate</p>
                  <p class="subject-data">test</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Supplier Name</p>
                  <p class="subject-data">{{
                      allocation?.allocatedDriver?.supplier ?
                        allocation?.allocatedDriver?.supplier : '-'
                    }}</p>
                </div>
              </div>
            </div>
            <div *ngIf="allocation?.driverCategory === 'OUTSOURCE_DRIVER'" class="sub-section">
              <div *ngIf="allocation?.allocatedDriverVehicle?.brand" class="item-row">
                <p class="subject-name">Brand</p>
                <p class="subject-data">{{ allocation?.allocatedDriverVehicle?.brand }}</p>
              </div>
              <div *ngIf="allocation?.allocatedDriverVehicle?.model" class="item-row">
                <p class="subject-name">Model</p>
                <p class="subject-data">{{ allocation?.allocatedDriverVehicle?.model }}</p>
              </div>
              <div *ngIf="allocation?.allocatedDriverVehicle?.registerNumber" class="item-row">
                <p class="subject-name">Reg. Number</p>
                <p class="subject-data">{{ allocation?.allocatedDriverVehicle?.registerNumber }}</p>
              </div>
              <div *ngIf="allocation?.allocatedDriverVehicle?.yearOfManufacture" class="item-row">
                <p class="subject-name">Year of Manufacture</p>
                <p class="subject-data">{{ allocation?.allocatedDriverVehicle?.yearOfManufacture | date: 'y' }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>
  </nz-tab>

  <nz-tab *appHasAnyPrivilege="''" nzTitle="Booking Cost Details">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="mt-5 grid xl:grid-cols-3 gap-8 overflow-scroll">
          <div class="col-span-3 xl:col-span-2 min-w-[660px]">
            <div class="item-row " style="margin-bottom: 10px !important;">
              <p class="subject-name">Payment Type</p>
              <p class="subject-data">{{ convertToNormalString(booking?.bookingCostInformation?.paymentType) }}</p>
            </div>
            <div>
              <div class="grid grid-cols-6 gap-2 place-items-start  pt-2">
                <div class="col-span-2">
                  <span class="subject-data">Description</span>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data justify-end">Currency Type</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data">Amount</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data">LKR Rate</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-end">LKR Amount</p>
                </div>


              </div>
              <nz-divider class="custom-margin"></nz-divider>
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-2">
                  <span class="subject-name">Total Rental Amount</span>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.totalRentalAmountCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p
                    class="subject-data text-start">{{ booking?.bookingCostInformation?.totalRentalAmount| number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.totalRentalAmountCurrencyDetails?.lkrRate | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">{{
                      booking?.bookingCostInformation?.totalRentalAmount *
                      booking?.bookingCostInformation?.totalRentalAmountCurrencyDetails?.lkrRate | number:'1.2-2'
                    }}</p>
                </div>


              </div>
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-2">
                  <span class="subject-name">Prepaid Amount</span>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.prepaidAmountCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p
                    class="subject-data text-start">{{ booking?.bookingCostInformation?.prepaidAmount | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.prepaidAmountCurrencyDetails?.lkrRate | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">{{
                      booking?.bookingCostInformation?.prepaidAmount *
                      booking?.bookingCostInformation?.prepaidAmountCurrencyDetails?.lkrRate | number:'1.2-2'
                    }}</p>
                </div>
              </div>
            </div>

            <div class="mt-5">
              <h6 class="mb-4">Cost Types and Amount</h6>
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-2">
                  <span class="subject-name">Due Rental Amount</span>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p
                    class="subject-data text-start">{{ booking?.bookingCostInformation?.rentalAmountDue | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails?.lkrRate | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">{{
                      booking?.bookingCostInformation?.rentalAmountDue *
                      booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails?.lkrRate | number:'1.2-2'
                    }}</p>
                </div>


              </div>
              <div class="mt-3">
                <div class="flex justify-between">
                  <p class="subject-name" style="color: #282828 !important;">Extra Charges</p>
                  <p class="subject-data"></p>
                </div>
                <nz-divider class="custom-margin"></nz-divider>
                <div class="">
                  <div *ngFor="let charge of booking?.bookingCostInformation?.extraCharges"
                       class="grid grid-cols-6 gap-2">
                    <div class="col-span-2">
                      <span class="subject-name">{{ charge?.chargeType }}</span>
                    </div>

                    <div class="flex flex-row w-full justify-end">
                      <p
                        class="subject-data text-start">{{
                          charge?.currencyDetails ? charge?.currencyDetails?.currencyCode
                            : 'LKR'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-end">{{ charge?.amount | number:'1.2-2' }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-start">{{
                          charge?.currencyDetails ? (charge?.currencyDetails?.lkrRate | number:'1.2-2') :
                            '-'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-end" >{{
                          charge?.currencyDetails ? ((charge?.amount *
                            charge?.currencyDetails?.lkrRate) | number:'1.2-2') : (charge?.amount | number:'1.2-2')
                        }}</p>
                    </div>


                  </div>
                </div>
                <div class="flex justify-between">
                  <p class="subject-name custom_font-bold">Total Extra Charges</p>
                  <p class="subject-data_1 text-start font-bold">{{ getTotalExtraCharges() | number:'1.2-2' }}</p>
                </div>
              </div>
              <div class="mt-3">
                <div class="flex justify-between">
                  <p class="subject-name" style="color: #282828 !important;">Deductions</p>
                  <p class="subject-data"></p>
                </div>
                <nz-divider class="custom-margin"></nz-divider>
                <div class="">
                  <div *ngFor="let deduc of booking?.bookingCostInformation?.deductions" class="grid grid-cols-6 gap-2">
                    <div class="col-span-2">
                      <span class="subject-name">{{ deduc?.chargeType }}</span>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p
                        class="subject-data text-start">{{
                          deduc?.currencyDetails ? deduc?.currencyDetails?.currencyCode :
                            'LKR'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-start">{{ deduc?.amount | number:'1.2-2' }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-start">{{
                          deduc?.currencyDetails ? (deduc?.currencyDetails?.lkrRate | number:'1.2-2') :
                            '-'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="subject-data text-start">{{
                          deduc?.currencyDetails ? ((deduc?.amount *
                            deduc?.currencyDetails?.lkrRate) | number:'1.2-2') : deduc?.amount | number:'1.2-2'
                        }}</p>
                    </div>


                  </div>
                </div>
                <div class="flex justify-between">
                  <p class="subject-name custom_font-bold">Total Deductions</p>
                  <p class="subject-data_1  ">{{ getTotalDeductions() | number:'1.2-2' }}</p>
                </div>
              </div>
              <div class="flex justify-between my-3">
                <p class="subject-name custom_font-bold">Total Cost</p>
                <p class="subject-data_1 font-bold">{{
                    ((booking?.bookingCostInformation?.rentalAmountDue *
                      booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails?.lkrRate) + getTotalExtraCharges()) -
                    getTotalDeductions() | number:'1.2-2'
                  }}</p>
              </div>

              <nz-divider class="custom-margin"></nz-divider>
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-2">
                  <span class="subject-name custom_font-bold">Refundable Deposit</span>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">
                    {{ booking?.bookingCostInformation?.depositCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">{{ booking?.bookingCostInformation?.deposit | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p
                    class="subject-data text-start">{{ booking?.bookingCostInformation?.depositCurrencyDetails?.lkrRate | number:'1.2-2' }}
                  </p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="subject-data text-start">{{
                      booking?.bookingCostInformation?.deposit *
                      booking?.bookingCostInformation?.depositCurrencyDetails?.lkrRate | number:'1.2-2'
                    }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-3 xl:col-span-1">
            <div class="sub-section">
              <p class="subject-name">Attachments</p>
              <div *ngIf="booking?.customerDetails?.localDrivingLicenseDetails?.attachments?.length > 0"
                   class="flex flex-row gap-2 items-center py-2">
                <div *ngFor="let at of booking?.customerDetails?.localDrivingLicenseDetails?.attachments"
                     class="flex flex-col">
                  <a href="{{at?.url}}" [nz-tooltip]="" target="_blank"><span nz-icon nzType="file" class="text-sm"
                                                                              nzTheme="outline"></span><span
                    class="ml-2 text-sm text-black"> - {{ at?.name }}</span></a>
                </div>
              </div>
              <div *ngIf="!(booking?.customerDetails?.localDrivingLicenseDetails?.attachments?.length > 0)"
                   class="flex flex-row gap-2 items-center py-2">
                <p class="subject-data">-</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-8">
          <div class="flex justify-between items-center mb-5">
            <h6 class="">Received Payments Details</h6>
            <button (click)="visibleAddPayment()" nz-button nzType="primary">
              Add Payment
            </button>
          </div>
          <div class="table-card overflow-scroll">
            <div class="table-obj">
              <nz-table #basicTable [nzData]="bookingPayments" [nzShowSizeChanger]="pageSize.length > 5"
                        [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                        [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                        nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
                        nzOuterBordered class="">
                <thead>
                <tr>
                  <th id="paymentType">Type</th>
                  <th id="paymentItems" class="w-3/12">Items</th>
                  <th id="paymentDescription" class="w-4/12">Description</th>
                  <th id="paymentAmount">Amount LKR</th>
                  <th id="paymentCreatedAt">Created Date</th>
                  <th id="paymentActions">Actions</th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let data of basicTable.data; let i = index" class="align-baseline">
                  <td>{{ data?.type | titlecase }}</td>
                  <td class="w-3/12">
                    <div *ngFor="let item of data?.items" class="flex gap-1">
                      <div>
                        <p class="text-sm font-bold">{{ item?.chargeType }} - </p>
                      </div>
                      <div>
                        <p class="text-sm">
                          {{ item?.amount | number:'1.2-2' }} {{ item?.currencyDetails?.currencyCode }} -
                        </p>
                      </div>
                      <div class="text-sm">
                        <p>{{ item?.amount * item?.currencyDetails?.lkrRate | number:'1.2-2' }} LKR</p></div>
                    </div>
                  </td>
                  <td class="w-4ßß/12">{{ data?.description }}</td>
                  <td>{{ data?.totalAmount | number:'1.2-2' }}</td>
                  <td>{{ data?.createdAt | date: 'dd-MM-y' }}</td>
                  <td>
                    <button class="outline-button more-dropdown" nz-button nz-dropdown [nzDropdownMenu]="menu"
                            nzPlacement="bottomCenter">
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li *appHasAnyPrivilege="'REPORT_GENERATE'" nz-menu-item nz-popconfirm nz-button (click)="showReportGenerate(true);generatePdf(data)">
                          Generate Receipt
                        </li>
                        <li nz-menu-item nz-popconfirm nz-button (click)="editPayment(i, data)">Edit</li>
                      </ul>
                    </nz-dropdown-menu>
                  </td>
                </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
        </div>
      </nz-card>

      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-single-view-skeleton-template [typeName]="'cost-detail'"></app-single-view-skeleton-template>
      </div>

    </section>
  </nz-tab>

  <nz-tab *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW,'"
          nzTitle="Other Details">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="mt-5 grid xl:grid-cols-2 gap-2">
          <div *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW'">
            <div class="flex mb-5">
              <p class="font-semibold mr-5">Special Instruction</p>
            </div>
            <textarea class="mt-2" rows="8" nz-input id="disabledTextarea" [(ngModel)]="specialInstruction"
                      disabled></textarea>
          </div>
          <div *appHasAnyPrivilege="''">
            <div class="flex mb-5 justify-between items-center">
              <p class="font-semibold mr-5">User Comments</p>
              <button *appHasAnyPrivilege="''" nz-button nzType="primary"
                      (click)="visibleAddEditComment('add')">Add Comment
              </button>
            </div>
            <div>
              <div class="grid grid-cols-12">
                <p class="col-span-2 text-sm mx-2 font-bold">Date</p>
                <p class="col-span-5 text-sm mx-2 font-bold">Comment</p>
                <p class="col-span-3 text-sm mx-2 font-bold">User</p>
                <p *appHasAnyPrivilege="''"
                   class="col-span-2 text-sm font-bold">Actions</p>
              </div>
            </div>
            <div *ngFor="let comment of userComments; index as i">
              <div class="grid grid-cols-12 mt-2 content-center">
                <p class="col-span-2 text-sm mx-2">{{ comment?.createdAt | date: 'dd-MM-y' }}</p>
                <p class="col-span-5  text-sm mx-2">{{ comment?.comment }}</p>
                <p class="col-span-3 text-sm mx-2">{{ comment?.createdBy?.name }}</p>
                <div *appHasAnyPrivilege="''"
                     class="flex justify-center gap-4 ">
                  <button class="outline-button more-dropdown" nz-button nz-dropdown [nzDropdownMenu]="commentMenu"
                          nzPlacement="bottomCenter">
                    <span nz-icon nzType="more" nzTheme="outline"></span>
                  </button>
                  <nz-dropdown-menu #commentMenu="nzDropdownMenu">
                    <ul nz-menu>
                      <li *appHasAnyPrivilege="''"
                          nz-menu-item nz-popconfirm nz-button
                          (click)="visibleAddEditComment('edit', comment, i)">Edit
                      </li>
                      <li *appHasAnyPrivilege="''" nz-menu-item nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this comment?"
                          [nzOkText]="'Yes'"
                          [nzCancelText]="'No'" (nzOnCancel)="cancelDeleteComment()"
                          (nzOnConfirm)="deleteComment(i)">Delete
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
              </div>
              <nz-divider></nz-divider>
            </div>
            <div class="grid grid-cols-5 mt-2 content-center">
              <p class="text-sm mx-2" *ngIf="!userComments || userComments.length ===0 ">
                <!-- Display content when userComments is not null and has items -->
              </p>
              <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                <!-- Display content when userComments is not null and has items -->
              </p>
              <p class="mx-2 mt-4" *ngIf="!userComments || userComments.length === 0">
                No Data
              </p>
              <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                <!-- Display content when userComments is not null and has items -->
              </p>
              <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                <!-- Display content when userComments is not null and has items -->
              </p>
            </div>
          </div>

          <div *appHasAnyPrivilege="''">
            <nz-divider></nz-divider>
            <div class="flex mb-5">
              <p class="font-semibold mr-5">Remarks</p>
            </div>
            <div>
              <div class="grid grid-cols-3">
                <p class="text-sm mx-2 font-bold">Date</p>
                <p class="text-sm mx-2 font-bold">Action</p>
                <p class="text-sm mx-2 font-bold">Remark</p>
              </div>
            </div>
            <div *ngFor="let remark of booking?.remarks">
              <div class="grid grid-cols-3 mt-2 content-center">
                <p class="text-sm mx-2">{{ remark?.createdAt | date: 'dd-MM-y' }}</p>
                <p class="text-sm mx-2">{{ remark?.action }}</p>
                <p class="text-sm mx-2">{{ remark?.remark }}</p>
              </div>
              <nz-divider></nz-divider>
            </div>
            <div class="grid grid-cols-3 mt-2 content-center">
              <p class="text-sm mx-2" *ngIf="!booking?.remarks === null || booking?.remarks?.length < 1">
              </p>
              <p class="text-sm mx-2 mt-4" *ngIf="!booking?.remarks === null || booking?.remarks?.length < 1">No
                Data</p>
              <p class="text-sm mx-2" *ngIf="!booking?.remarks === null || booking?.remarks?.length < 1">
              </p>
            </div>
          </div>
        </div>
      </nz-card>
    </section>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
    </div>
  </nz-tab>

  <nz-tab nzTitle="Reports" *appHasAnyPrivilege="'REPORT_GENERATE'">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-5">
          <div>
            <h5>Generate Reports</h5>
            <div class="mt-5">
              <hr>
              <div
                class="flex flex-col min-[400px]:flex-row  min-[400px]:justify-between min-[400px]:items-center w-full gap-2">
                <div class="flex items-center gap-2">
                  <span nz-icon nzType="file" nzTheme="outline" class="icon-color"></span>
                  <p>Rental Agreement</p>
                </div>
                <div class="sm:mr-5">
                  <button nz-button nzType="primary" class="max-[400px]:w-full" (click)="openRentalAgreementModal()">
                    Generate
                  </button>
                </div>
              </div>
              <hr>
              <div
                class="flex flex-col min-[400px]:flex-row  min-[400px]:justify-between min-[400px]:items-center gap-2">
                <div class="flex items-center gap-2">
                  <span nz-icon nzType="file" nzTheme="outline" class="icon-color"></span>
                  <p>Paging Board</p>
                </div>
                <div class="sm:mr-5">
                  <button nz-button nzType="primary" class="max-[400px]:w-full"
                          (click)="openGeneratePagingBoardModal()">Generate
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>
        </div>

      </nz-card>
    </section>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'report'"></app-single-view-skeleton-template>
    </div>

  </nz-tab>
</nz-tabset>

<nz-modal [(nzVisible)]="isVisibleFuelAndMileageUpdate" [nzTitle]="modalTitle" [nzContent]="modalContent"
          [nzFooter]="modalFooter" (nzOnCancel)="handleCancelUpdateFuelAndMileage()">
  <ng-template #modalTitle>
    {{ changingStatus === 'CANCELLED' ? 'Reason for Cancellation' : 'Current Fuel and Mileage Update' }}
  </ng-template>

  <ng-template #modalContent>
    <div
      *ngIf="changingStatus === 'ON_RENT' || changingStatus === 'COMPLETED' || mileageAndFuelDataType === 'add-allocation'"
      class="flex flex-col gap-4">
      <p class="font-bold">{{ changingStatus === 'ON_RENT' ? 'Start' : 'End' }} Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>

      <p class="font-bold">{{ changingStatus === 'ON_RENT' ? 'Start' : 'End' }} Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel"
               placeholder="Enter Fuel Level"/>
      </nz-input-group>
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select class="w-full" [(ngModel)]="cancelReason" nzPlaceHolder="Select Preference" nzShowSearch nzAllowClear
                 [nzDropdownRender]="renderTemplate">
        <nz-option *ngFor="let item of cancelReasonOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement/>
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelUpdateFuelAndMileage()">Cancel</button>
    <button *ngIf="!(changingStatus === 'CANCELLED')" nz-button nzType="primary"
            [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)" nz-popconfirm
            nzPopconfirmTitle="{{mileageAndFuelDataType === 'add-allocation' ?
            'Are you sure you want to save this information and add another allocation?' :
            'Are you sure you want to save this information and change the status?'}}"
            [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkUpdateFuelAndMileage()" [nzLoading]="isLoading">Save
    </button>
    <button *ngIf="changingStatus === 'CANCELLED'" nz-button nzType="primary" [disabled]="(cancelReason === null)"
            nz-popconfirm nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkCancelledStatus()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleAddEditComment" [nzTitle]="commentModalTitle" [nzContent]="commentModalContent"
          [nzFooter]="commentModalFooter" (nzOnCancel)="handleCancelAddEditComment()">
  <ng-template #commentModalTitle>{{ selectedComment ? 'Edit Comment' : 'Add Comment' }}</ng-template>

  <ng-template #commentModalContent>
    <div class="flex flex-col gap-4">
      <p class="font-bold">Comment</p>
      <textarea nz-input placeholder="Enter Comment" [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                [(ngModel)]="comment"></textarea>
    </div>
  </ng-template>

  <ng-template #commentModalFooter>
    <button nz-button nzType="default" (click)="handleCancelAddEditComment()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="(comment === null)" nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information ?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelAddEditComment()" (nzOnConfirm)="handleSubmitUserComment()"
            [nzLoading]="isLoadingCommentModal">Save
    </button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleAddAllocation" [nzTitle]="modal3Title" [nzContent]="modal3Content"
          [nzFooter]="modal3Footer" (nzOnCancel)="handleCancelAllocation()">
  <ng-template #modal3Title>Add Another Allocation</ng-template>

  <ng-template #modal3Content>

    <form nz-form [formGroup]="allocationForm" [nzLayout]="'vertical'">
      <div class="grid grid-cols-1 gap-4">
        <div>
          <div class="grid grid-cols-2 gap-2">
            <span nz-checkbox formControlName="isUpgraded" class="mb-3"
                  (nzCheckedChange)="setValues($event, 'upgrade')">Vehicle Upgrade</span>
            <span nz-checkbox formControlName="isDowngraded" class="mb-3"
                  (nzCheckedChange)="setValues($event, 'downgrade')">Vehicle Downgrade</span>
          </div>
          <div *ngIf="allocationForm?.get('isDowngraded').value || allocationForm?.get('isUpgraded').value"
               class="grid grid-cols-1 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
              <nz-form-control [nzErrorTip]="vehicleCategoryError">
                <nz-select class="w-full" formControlName="vehicleCategory" nzPlaceHolder="Select Preference"
                           (ngModelChange)="getVehicles($event)">
                  <nz-option *ngFor="let data of vehicleCategories" [nzValue]="data._id"
                             [nzLabel]="data.name"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #vehicleCategoryError>
                <span *ngIf="formErrors?.vehicleCategory?.required">Please select category. </span>
              </ng-template>
            </nz-form-item>
          </div>

          <div class="grid grid-cols-1 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="allocatedVehicle" nzRequired>Allocated Vehicle</nz-form-label>
              <nz-form-control [nzErrorTip]="allocatedVehicleError">
                <nz-select class="w-full" formControlName="allocatedVehicle" nzPlaceHolder="Select Preference">
                  <nz-option *ngFor="let op of fleetsOptions" nzValue="{{op._id}}"
                             nzLabel="{{op.vehicleName}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #allocatedVehicleError>
                <span *ngIf="formErrors?.allocatedVehicle?.required">Please select vehicle. </span>
              </ng-template>
              <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
            </nz-form-item>
          </div>

          <div *ngIf="allocationForm.get('isUpgraded').value">
            <span nz-checkbox formControlName="isComplementary" class="mb-4">Complementary</span>
            <nz-form-item *ngIf="allocationForm.get('isComplementary').value" class="grid grid-flow-row content-start">
              <nz-form-label nzFor="reason">Reason</nz-form-label>
              <nz-form-control [nzErrorTip]="reasonError">
                <textarea nz-input formControlName="reason" placeholder="Enter Reason"
                          [nzAutosize]="{ minRows: 5, maxRows: 5 }"></textarea>
              </nz-form-control>
              <ng-template #reasonError>
                <span *ngIf="formErrors?.reason?.maxlength">Maximum 150 letters only. </span>
              </ng-template>
            </nz-form-item>
          </div>

          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="fuelType" nzRequired>Fuel Type</nz-form-label>
            <nz-form-control [nzErrorTip]="fuelTypeError">
              <nz-select class="w-full" formControlName="fuelType" nzPlaceHolder="Select Preference">
                <nz-option nzValue="a" nzLabel="Petrol 95 Oct"></nz-option>
                <nz-option nzValue="b" nzLabel="Super Diesel"></nz-option>
                <nz-option nzValue="c" nzLabel="Electric"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #fuelTypeError>
              <span *ngIf="formErrors?.fuelType?.required">Please select fuel type. </span>
            </ng-template>
          </nz-form-item>

          <div class="grid grid-cols-1 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="startMileage">Start Mileage ( KM )</nz-form-label>
              <nz-form-control [nzErrorTip]="startMileageError">
                <input nz-input type="number" [min]="0" formControlName="startMileage" placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #startMileageError>
                <span *ngIf="formErrors?.startMileage?.required">Please enter mileage. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="startFuel">Start Fuel ( % )</nz-form-label>
              <nz-form-control [nzErrorTip]="startFuelError">
                <input nz-input type="number" [min]="0" formControlName="startFuel" placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #startFuelError>
                <span *ngIf="formErrors?.startFuel?.required">Please enter fuel level. </span>
              </ng-template>
            </nz-form-item>
          </div>


        </div>

        <div>
          <span nz-checkbox formControlName="isDriverPromote" class="mb-4" (ngModelChange)="checkValue($event)">Driver
            Promotion</span>
          <div *ngIf="allocationForm.get('isDriverPromote').value">
            <div class="grid grid-cols-1 gap-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="driverPromotionDue" nzRequired>Driver Promotion Due to</nz-form-label>
                <nz-form-control [nzErrorTip]="driverPromotionDueError">
                  <nz-select [nzDropdownRender]="renderTemplate" class="w-full" formControlName="driverPromotionDue"
                             nzPlaceHolder="Select Preference">
                    <nz-option *ngFor="let item of driverPromotionDueOptions" [nzLabel]="item"
                               [nzValue]="item"></nz-option>
                  </nz-select>
                  <ng-template #renderTemplate>
                    <nz-divider></nz-divider>
                    <div class="flex flex-col justify-center mx-3">
                      <input type="text" nz-input #inputElement/>
                      <a class="text-center m-1" (click)="addDriverPromotionDue(inputElement)">
                        <span nz-icon nzType="plus"></span>
                        Add item
                      </a>
                    </div>
                  </ng-template>
                </nz-form-control>
                <ng-template #driverPromotionDueError>
                  <span *ngIf="formErrors?.driverPromotionDue?.required">Please select reason. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="driverCategory" nzRequired>Driver Category</nz-form-label>
                <nz-form-control [nzErrorTip]="driverCategoryError">
                  <nz-select class="w-full" formControlName="driverCategory" nzPlaceHolder="Select Preference"
                             (ngModelChange)="getDriverOptions($event)">
                    <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>
                    <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #driverCategoryError>
                  <span *ngIf="formErrors?.driverCategory?.required">Please select category. </span>
                </ng-template>
              </nz-form-item>
            </div>
            <div>
              <span nz-checkbox formControlName="isDriverPromotionCompCheck" class="mb-4">Complementary</span>
              <nz-form-item *ngIf="allocationForm.get('isDriverPromotionCompCheck').value"
                            class="grid grid-flow-row content-start">
                <nz-form-label nzFor="driverPromotionReason">Reason</nz-form-label>
                <nz-form-control [nzErrorTip]="driverPromotionReasonError">
                  <textarea nz-input formControlName="driverPromotionReason" placeholder="Enter Reason"
                            [nzAutosize]="{ minRows: 5, maxRows: 5 }"></textarea>
                </nz-form-control>
                <ng-template #driverPromotionReasonError>
                  <span *ngIf="formErrors?.driverPromotionReason?.maxlength">Maximum 150 letters only. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
          <div *ngIf="allocationForm.get('driverCategory').value &&
            allocationForm.get('isDriverPromote').value" class="grid grid-cols-1 gap-2 mb-6">
            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="allocatedDriver" nzRequired>Allocated Driver</nz-form-label>
              <nz-form-control [nzErrorTip]="allocatedDriverError">
                <nz-select class="w-full" formControlName="allocatedDriver" nzPlaceHolder="Select Preference"
                           (ngModelChange)="getSupplierVehicles($event)">
                  <nz-option *ngFor="let op of driverOptions" nzValue="{{op._id}}"
                             nzLabel="{{op.fullName}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #allocatedDriverError>
                <span *ngIf="formErrors?.allocatedDriver?.required">Please select driver. </span>
              </ng-template>
              <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
            </nz-form-item>
            <div class="flex items-end">
              <button class="outline-button" nz-button nzType="default" (click)="showAddDriverPopup()">Add New
                Driver
              </button>
            </div>
          </div>
          <div *ngIf="((allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER'))"
               class="grid grid-cols-1 gap-2 mb-6">
            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="allocatedDriverVehicle" nzRequired>Allocated Vehicle</nz-form-label>
              <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                <nz-select class="w-full" formControlName="allocatedDriverVehicle" nzPlaceHolder="Select Preference">
                  <nz-option *ngFor="let op of supplierVehicleOptions" nzValue="{{op?._id}}"
                             nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #allocatedDriverVehicleError>
                <span *ngIf="formErrors?.allocatedDriverVehicle?.required">Please select supplier vehicle. </span>
              </ng-template>
              <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
            </nz-form-item>
            <div class="flex items-end">
              <button class="outline-button" nz-button nzType="default" nz-popconfirm
                      (click)="showAddVehicleToSupplier()">Add New Vehicle
              </button>
              | number:'1.2-2'
            </div>
          </div>
          <div *ngIf="((allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER'))"
               class="grid grid-cols-1 gap-2 mb-6">
            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="outsourcedRate" nzRequired>Outsourced Rate</nz-form-label>
              <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate">
                  <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                   [nzMin]="0"></nz-input-number>
                </nz-input-number-group>
                <ng-template #addOnAfterTemplate>
                  <nz-select formControlName="outsourcedRateCurrency" [nzPlaceHolder]="'...'" style="width: 75px">
                    <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                               [nzLabel]="op.currencyCode"></nz-option>
                  </nz-select>
                </ng-template>
              </nz-form-control>
              <ng-template #allocatedDriverVehicleError>
                <span *ngIf="formErrors.oursourcedRate?.required">Please enter price rate </span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #modal3Footer>
    <button nz-button nzType="default" (click)="handleCancelAllocation()">Cancel</button>
    <button nz-button nzType="primary" nz-popconfirm nzPopconfirmTitle="Are you sure you want to save this information?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelAllocation()"
            (nzOnConfirm)="saveAllocation()" [disabled]="this.allocationForm.invalid">Save
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isShowReport"
  [nzTitle]="modalTitle12"
  [nzContent]="modalContent12"
  [nzFooter]="modalFooter12"
  (nzOnCancel)="handleCancel()"
  nzClosable="false"
>
  <ng-template #modalTitle12>
    <div class="flex justify-between items-center my-4">
      <h4>{{ isReportPaymentReceipt ? 'Payment Receipt' : 'Invoice for Outsource Vehicle' }}</h4>
      <button nz-button nzType="primary" [disabled]="!this.pdfLoader" (click)="viewPdf()">Preview</button>
    </div>
  </ng-template>

  <ng-template #modalContent12>
    <div class="my-4">
      <p style="font-weight: normal; color:#F06A21" *ngIf="!this.pdfLoader">Report Generating ....</p>
      <p style="font-weight: normal" *ngIf="this.pdfLoader">Report Generated Successfully!</p>
    </div>
  </ng-template>

  <ng-template #modalFooter12>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" style="color: white; background: #9A9A9A;border-color: #9A9A9A"
              (click)="handleCancel()">
        Cancel
      </button>
      <div class="flex gap-2">
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="downloadPdf()">
          Download
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="emailPdf()">
          Send
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="printReport()">
          Print
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>


<app-single-view-customer-popup [customerData]="customerData" [isVisible]="isVisibleCustomer"
                                (viewCustomerOnchange)="visibleCustomerOnchange($event)"></app-single-view-customer-popup>

<app-single-view-supplier-popup *ngIf="isVisibleSupplier" [supplierId]="supplierId" [isVisible]="isVisibleSupplier"
                                (viewSupplierOnchange)="visibleSupplierOnchange($event)"></app-single-view-supplier-popup>

<app-single-view-driver-popup [isVisible]="isVisibleDriver" [driverData]="driverData"
                              (viewDriverOnchange)="visibleDriverOnchange($event)"></app-single-view-driver-popup>

<app-payment-popup *ngIf="visiblePaymentPopup" [isVisible]="visiblePaymentPopup"
                   [chargesOptions]="paymentItems"
                   (addPaymentOnChange)="onGetAddPaymentChange($event)"></app-payment-popup>

<app-add-driver-popup *ngIf="visibleAddDriverPopup" [isVisible]="visibleAddDriverPopup"
                      (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>

<app-vehicle-details-form *ngIf="visibleAddVehicleToSupplier" [isVisible]="visibleAddVehicleToSupplier"
                          (addVehicleOnChange)="addVehicleOnChange($event)"
                          [supplier]="selectedSupplierId"></app-vehicle-details-form>

<app-generate-inventory-report-popup
  *ngIf="isVisibleGenerateInventoryReport"
  (handleGenerateInventoryReportOnChange)="onGetGenerateInventoryReportChange($event)"
  [isVisibleGenerateInventoryReport]="isVisibleGenerateInventoryReport"
  [inventoryId]="relevantInventoryId"
  [bookingData]="bookingData"
></app-generate-inventory-report-popup>
<app-generate-paging-board-popup *ngIf="isVisibleGeneratePagingBoardModal"
                                 (handleGeneratePagingBoardModalOnChange)="onGetGeneratePagingBoardChange($event)"
                                 [isVisibleGeneratePagingBoardModal]="isVisibleGeneratePagingBoardModal"
                                 [pagingBoardData]="defaultPagingBoardData"
></app-generate-paging-board-popup>
<app-generate-report-modal *ngIf="isVisibleGenerateReportModal"
                           (handleGenerateReportModalOnChange)="onGenerateReportChange($event)"
                           [isVisibleGenerateReportModal]="isVisibleGenerateReportModal"
                           [reportData]="generateReportData"
                           [headerName]="'Rental Agreement'"
></app-generate-report-modal>
